<div class="fixed inset-0 bg-black/50 flex items-center justify-center z-[10500]" *ngIf="showLoader">
    <div class="bg-white rounded-2xl p-[30px] max-w-xl relative">
        <div class="loader"></div>
    </div>
</div>